import { Search } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { t } from '../../../locales/translate';

const SearchInput = ({ placeholder, onChange, value }) => {
  const [inputValue, setInputValue] = useState(value || '');
  
  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '320px',
    color: '#666',
    height: '40px',
    padding: '8px 10px',
    gap: '10px',
    border:'1px solid #E0E0E0',
    borderRadius: '60px',
    opacity: '0.9',
    background: 'transparent',
  };

  const iconStyle = {
    fontSize: '18px',
    color: '#666',
  };

  const inputStyle = {
    width: '100%',
    border: 'none',
    background: 'transparent',
    outline: 'none',
    fontSize: '14px',
    color: '#333',
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
     if (newValue === '') {
      onChange({ target: { value: newValue } });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onChange({ target: { value: inputValue } });
    }
  };

  // const handleBlur = () => {
  //   onChange({ target: { value: inputValue } });
  // };

  return (
    <div style={containerStyle}>
      <Search style={iconStyle} />
      <input
        type="text"
        style={inputStyle}
        placeholder={t("search")}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        // onBlur={handleBlur}
        value={inputValue}
      />
    </div>
  );
};

export default SearchInput;